import type {GroupRepo, ItemId, ItemVariantId} from "./GroupRepo";
import {useIndex} from "./use-index";
import {useResultTable, useSortedResultRowIds} from "./use-query";

export const getIncompleteVariants = (repo: GroupRepo) =>
  Object.values(repo.queries.getResultTable("incompleteVariants")).map((rawVariant) =>
    repo.ItemVariants.hydrate(rawVariant)
  );
export const useIncompleteVariants = (groupRepo: GroupRepo) =>
  useResultTable(groupRepo.queries, "incompleteVariants", groupRepo.ItemVariants.hydrate);

export const useJustCompletedVariants = (groupRepo: GroupRepo, count: number) =>
  useSortedResultRowIds<ItemVariantId>(
    groupRepo.queries,
    "completedVariants",
    "completedAt",
    true,
    0,
    count
  );

export const getVariantIdsByItemId = (groupRepo: GroupRepo, itemId: ItemId) => {
  return groupRepo.indexes.getSliceRowIds("variantByItemId", itemId) as ItemVariantId[];
};

export const useVariantIdsByItemId = (groupRepo: GroupRepo, itemId: ItemId) => {
  return useIndex<ItemVariantId>(itemId, groupRepo.indexes, "variantByItemId");
};
